import React from 'react'
import resolveIcon from '../icon/resolveIcon'
import SavingIndicator from '../SavingIndicator'
import SavingStatus from '../SavingStatus'

// TODO: Cuando termine la migración de GoogleIcon a Phosphor, quitar
// primaryIconName y el fallback de string.
export default function FormHeaderSaveActions({
  onBack,
  onCancel,
  onPrimaryClick,
  backLabel = 'Atrás',
  cancelLabel = 'Cancelar',
  primaryLabel = 'Guardar',
  savingLabel = 'Guardando...',
  isSaving = false,
  primaryDisabled = false,
  primaryButtonType = 'submit',
  showPrimaryIcon = true,
  primaryIcon: PrimaryIcon = null,
  primaryIconName = 'check_circle',
  primaryIconNode = null,
  primaryIconSize = 16,
  primaryIconWeight = 'regular',
  className = '',
  stackOnMobile = false,
  hideSecondaryActions = false
}) {
  const rootClass = [
    'form-header-actions',
    stackOnMobile ? 'form-header-actions--stack-mobile' : '',
    className
  ]
    .filter(Boolean)
    .join(' ')

  const resolvedPrimaryIcon = resolveIcon({
    icon: PrimaryIcon,
    iconNode: primaryIconNode,
    googleName: primaryIconName,
    size: primaryIconSize,
    weight: primaryIconWeight
  })
  const showSecondaryActions = !hideSecondaryActions

  return (
    <div className={rootClass}>
      <SavingStatus isSaving={isSaving} label={savingLabel} />
      {showSecondaryActions && onBack && (
        <button
          type="button"
          className="form-header-action-btn form-header-action-btn--ghost"
          onClick={onBack}
          disabled={isSaving}
        >
          {backLabel}
        </button>
      )}

      {showSecondaryActions && (
        <button
          type="button"
          className="form-header-action-btn form-header-action-btn--secondary"
          onClick={onCancel}
          disabled={isSaving}
        >
          {cancelLabel}
        </button>
      )}

      <button
        type={primaryButtonType}
        className={[
          'form-header-action-btn',
          'form-header-action-btn--primary',
          isSaving ? 'form-header-action-btn--saving' : ''
        ]
          .filter(Boolean)
          .join(' ')}
        onClick={onPrimaryClick}
        disabled={isSaving || primaryDisabled}
      >
        {isSaving ? (
          <SavingIndicator label={savingLabel} size={16} />
        ) : (
          <>
            {showPrimaryIcon && resolvedPrimaryIcon && (
              <span className="form-header-action-btn__icon" aria-hidden="true">
                {resolvedPrimaryIcon}
              </span>
            )}
            {primaryLabel}
          </>
        )}
      </button>
    </div>
  )
}
